import React from 'react';

import i18n from '../../i18n';
import { MenuItem, TextField } from '@mui/material';

// @mui

export default class DialogStateField extends React.Component {
    // field, value, onChange

    onChange(event) {
        this.props.onChange(event.target.name, event.target.value);
    }

    render() {
        // field, value, cache, onChange

        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        let id = this.props.field.id;
        let name = this.props.field.label;
        let value = this.props.value ? this.props.value.toLowerCase() : '';


        return (
            <TextField
                key={id}
                select
                margin="dense"
                id={id}
                name={name}
                label={translatedName}
                defaultValue={value}
                fullWidth
                onChange={(event) => this.onChange(event)}>
                {
                    this.props.field.items.map(item => (
                        <MenuItem key={item} value={item.toLowerCase()}>
                            {i18n.t(`enums.${item}`)}
                        </MenuItem>
                    ))
                }
            </TextField>
        );
    }
}